export default (path) => (
  new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = path;

    link.addEventListener('load', resolve);

    document.head.appendChild(link);
  })
);
